import React, {Component} from "react"
import { withSiteData, Link, Head } from 'react-static'

import ScrollMagic from "utils/ScrollMagic"
import ScrollToPlugin from "gsap/ScrollToPlugin"

class Header extends Component {
  componentDidMount() {
    // forEach method, could be shipped as part of an Object Literal/Module
    var forEach = function (array, callback, scope) {
      for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]); // passes back stuff we need
      }
    };

    var controller = new ScrollMagic.Controller();
    // sections
    var sectionsList = document.querySelectorAll('section');
    var sectionsHeight = [];

    forEach(sectionsList, function (index, section) {
      sectionsHeight[index] = section.offsetHeight;
    });

    var navigationScene = new ScrollMagic.Scene({ triggerElement: '.lovePower', triggerHook: 1, duration: '100%' });
    var navigationSceneTL = new TimelineMax().add([
      TweenMax.from('nav .pagesNav', 1, {  css:{ autoAlpha: 0 }, ease: Power0.easeNone  }),
      TweenMax.to('nav .logoContainer .logoMark svg path, nav .hambergerMenu', 1, {  css:{ color: '#f84739', fill: '#f84739' },  ease: Power0.easeNone  }),
      TweenMax.to('nav .logoContainer .logoType', 1, {  css:{ autoAlpha: 0, color: '#f84739' },  ease: Power0.easeNone  })
    ]);
    navigationScene.setTween(navigationSceneTL).addTo(controller);
    
    // Pagination
    // change behaviour of controller to animate scroll instead of jump
    controller.scrollTo(function (newpos) {
      TweenLite.to(window, 0.7, {scrollTo: {y: newpos, autoKill:false}, ease: Power4.easeOut });
    });
    var pagesNavItems = document.querySelectorAll('nav .pagesNav .navItem')
    forEach(sectionsList, function (index, section) {
      // handle clicks on dots
      pagesNavItems[index].addEventListener("click", function(){
        controller.scrollTo(section);
      });
      // highlight dots when page is active
      var paginationScene = new ScrollMagic.Scene({ triggerElement: section, triggerHook: 0, duration: sectionsHeight[index] })
        .setClassToggle(pagesNavItems[index], 'selected')
        .addTo(controller);
    });
    // hide Pagination on footer
    var footerNavigationScene = new ScrollMagic.Scene({ triggerElement: '.OurSites', triggerHook: 0, duration: `10%` })
      .setTween('nav .pagesNav', 1, { css:{ autoAlpha: 0 }, ease: Power0.easeNone })
      .addTo(controller);
    // logo click scroll to top
    document.querySelector('nav .logoContainer').addEventListener("click", function(){
      controller.scrollTo('.hero');
    });

    // Hamburger
  var openHamburgerModal = function () {
    var burgerIcon = document.querySelector('nav .hamburger');
    var hamburgerModal = document.querySelector('nav .hamburgerModal');
    burgerIcon.classList.add('is-active');
    // hamburgerModal.classList.add('is-opened');
    document.body.style.overflow = 'hidden';
    TweenLite.fromTo(document.querySelector('nav .hamburgerModal'), 0.4, { css:{ scale: .7} }, { css:{ scale: 1, autoAlpha: 1 },  ease: Power4.easeOut  });

  };
  var closeHamburgerModal = function () {
    var burgerIcon = document.querySelector('nav .hamburger');
    var hamburgerModal = document.querySelector('nav .hamburgerModal');
    burgerIcon.classList.remove('is-active');
    // hamburgerModal.classList.remove('is-opened');
    document.body.style.overflow = 'auto';
    TweenLite.fromTo(document.querySelector('nav .hamburgerModal'), 0.4, { css:{ scale: 1} }, { css:{ scale: .7, autoAlpha: 0 },  ease: Power4.easeOut  });
  };
  var forEach = function (array, callback, scope) {
    for (var i = 0; i < array.length; i++) {
      callback.call(scope, i, array[i]); // passes back stuff we need
    }
  };
  document.querySelector('nav .hamburger').addEventListener("click", function(){
    var burgerIcon = document.querySelector('nav .hamburger');
    var hamburgerModal = document.querySelector('nav .hamburgerModal');
    if ((' ' + burgerIcon.className + ' ').indexOf(' ' + 'is-active' + ' ') > -1) {
      closeHamburgerModal();
    } else {
      openHamburgerModal();
    }
  });
  document.querySelector('nav .hamburgerModal .menuItem.value').addEventListener("click", function(){
    closeHamburgerModal();
    controller.scrollTo('.lovePower');
  });
  document.querySelector('nav .hamburgerModal .menuItem.story').addEventListener("click", function(){
    closeHamburgerModal();
    controller.scrollTo('.ourStory');
  });
  document.querySelector('nav .hamburgerModal .menuItem.mission').addEventListener("click", function(){
    closeHamburgerModal();
    controller.scrollTo('.connectingHearts');
  });
  document.querySelector('nav .hamburgerModal .menuItem.sites').addEventListener("click", function(){
    closeHamburgerModal();
    controller.scrollTo('.OurSites');
  });
  }

  render()
  {
    return (
      <nav>
          <div className="logoContainer">
            <a className="logoMark" href="/">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path xmlns="http://www.w3.org/2000/svg" d="M1779.642,564.261l4.579,4.583a2.14,2.14,0,0,1,0,3.024l-6.089,6.1-6.09,6.095a2.135,2.135,0,0,1-3.022,0l-12.179-12.19a2.14,2.14,0,0,1,0-3.024l4.579-4.583a2.136,2.136,0,0,1,3.022,0l4.579,4.583a2.135,2.135,0,0,0,3.022,0l4.579-4.583A2.135,2.135,0,0,1,1779.642,564.261Zm-5.268-5.273-2.333,2.335a2.135,2.135,0,0,1-3.022,0l-2.332-2.335-.812-.812a4.163,4.163,0,0,0-5.891,0l-.812.812-7.6,7.607-.812.813a4.172,4.172,0,0,0,0,5.9l.812.812,15.2,15.215.812.812a4.163,4.163,0,0,0,5.891,0l.812-.812,7.6-7.608,7.6-7.607.812-.812a4.172,4.172,0,0,0,0-5.9l-.812-.813-7.6-7.607-.812-.812a4.163,4.163,0,0,0-5.891,0Z" transform="translate(-1749.541 -556.955)"></path>
              </svg>
            </a>
            <div className="logoType">World Singles<br/>Networks</div>
          </div>

          <div className="hambergerMenu">
            <div className="hamburgerModal">
              <div className="overlay"></div>
              <div className="menuItems">
                <span className="value menuItem">Our Values</span>
                <span className="story menuItem">Our Story</span>
                <span className="mission menuItem">Our Mission</span>
                <span className="sites menuItem">Our Sites</span>
              </div>
            </div>
            <div className="hamburger hamburger--spin" tabIndex="0">
              <div className="hamburger-box">
                <div className="hamburger-inner"></div>
              </div>
            </div>
          </div>

          <div className="pagesNav">
            <span className="navItem">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" style={{width: '7px', height: '7px'}}>
                <path d="M7.5,0C11.642,0,15,3.358,15,7.5S11.642,15,7.5,15 C3.358,15,0,11.642,0,7.5S3.358,0,7.5,0z"/>
              </svg>
            </span>
            <span className="navItem">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" style={{width: '7px', height: '7px'}}>
                <path d="M7.5,0C11.642,0,15,3.358,15,7.5S11.642,15,7.5,15 C3.358,15,0,11.642,0,7.5S3.358,0,7.5,0z"/>
              </svg>
            </span>
            <span className="navItem">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" style={{width: '7px', height: '7px'}}>
                <path d="M7.5,0C11.642,0,15,3.358,15,7.5S11.642,15,7.5,15 C3.358,15,0,11.642,0,7.5S3.358,0,7.5,0z"/>
              </svg>
            </span>
            <span className="navItem">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" style={{width: '7px', height: '7px'}}>
                <path d="M7.5,0C11.642,0,15,3.358,15,7.5S11.642,15,7.5,15 C3.358,15,0,11.642,0,7.5S3.358,0,7.5,0z"/>
              </svg>
            </span>
            <span className="navItem">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" style={{width: '7px', height: '7px'}}>
                <path d="M7.5,0C11.642,0,15,3.358,15,7.5S11.642,15,7.5,15 C3.358,15,0,11.642,0,7.5S3.358,0,7.5,0z"/>
              </svg>
            </span>
          </div>

        </nav>
    )
  }
}
export default withSiteData(Header);



// WEBPACK FOOTER //
// /usr/src/app/src/containers/Header.js